import React from 'react'
import { Trans } from '@lingui/macro'

import Loader from '../../../../components/common/loader/Loader'
import PathwayCard from '../../../student-pathways-page/components/PathwayCard'
import CardGrid from '../../../../components/common/card-grid/CardGrid'
import { linkBuilder, staticLinks } from 'shared/linkBuilder'
import { useAssignedPathwaysQuery } from './YourPathways.codegen'
import { Box, LinkBox } from 'front-end/src/components'

import './YourPathways.less'
import IconDots from 'front-end/src/components/common/icon/IconDots'
import { navigateTo } from 'front-end/src/app/util/appHistory'
import { AssignedPathwaysOrderEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

const YourPathways = () => {
  const { data, loading } = useAssignedPathwaysQuery({
    fetchPolicy: 'network-only',
    variables: {
      orderPathwayEnrolments: AssignedPathwaysOrderEnum.created_at
    }
  })

  if (loading) {
    return <Loader />
  }

  const assignedPathways = data?.me.assignedPathways

  if (!assignedPathways || assignedPathways.length === 0) {
    return null
  }

  const assignedPathwaysWithEnrolment = assignedPathways
    .filter((pathway) => pathway.currentEnrolment)
    .slice(0, 3)

  const showMore = assignedPathways.length > 3

  return (
    <div className="YourPathways">
      <div className="grid-header">
        <h3>
          <Trans>Your pathways</Trans>
        </h3>
      </div>

      <div className="YourPathwaysGrid">
        <CardGrid
          cards={assignedPathwaysWithEnrolment.map((pathway, index) => (
            <PathwayCard
              linkUrl={linkBuilder.pathwayDetail(pathway.id)}
              key={index}
              pathway={pathway}
              progress={pathway.currentEnrolment?.progress}
            />
          ))}
        >
          {showMore && (
            <LinkBox
              className="Card PathwayCard ExpandableCardGrid__more"
              onClick={() => navigateTo(staticLinks.pathways)}
            >
              <Box
                alignItems="center"
                className="ExpandableCardGrid__more__box"
              >
                <IconDots boxSize="28px" opacity=".5" mb="16px" />
                <Trans>View all your pathways</Trans>
              </Box>
            </LinkBox>
          )}
        </CardGrid>
      </div>
    </div>
  )
}

export default YourPathways
